import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../../common/html/button'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { InputRename } from '../../../common/html/input/InputRename'
import { TextTwoLine } from '../../../common/html/text'
import {
  changeCheckboxTable,
  selectCheckboxPortfolio,
} from '../store/slice/slice'

export const CustomTdTitle = ({
  item,
  rowId,
  colId,
  isRename,
  isShowRenameOnly,
  setIsShowRenameOnly,
}) => {
  const dispatch = useDispatch()

  const isCheck = useSelector(
    selectCheckboxPortfolio(['listIdsSelected', rowId]),
  )
  const listCheckbox = useSelector(selectCheckboxPortfolio(['listIdsSelected']))
  const isCanNavigate = !Object.values(listCheckbox).some(Boolean)

  const [showRename, setIsShowRename] = useState(false)
  const [showInput, setShowInput] = useState(false)

  const handleCheckbox = (value) => {
    dispatch(
      changeCheckboxTable({
        path: ['listIdsSelected', rowId],
        data: value,
      }),
    )
  }

  useEffect(() => {
    if (showInput) {
      setIsShowRenameOnly(true)
    }
  }, [showInput])

  return (
    <>
      <Element
        className="dFlex alignItemsCenter flex1 wh100"
        onMouseOver={() => setIsShowRename(true)}
        onMouseOut={() => setIsShowRename(false)}
        style={{ padding: '4px 12px' }}
        onClick={() => {
          if (!isCanNavigate) {
            handleCheckbox(!isCheck)
          }
        }}
      >
        <div style={{ paddingRight: 26 }}>
          <Checkbox
            checked={isCheck}
            styleIcon={{ fontSize: 13 }}
            onChange={handleCheckbox}
          />
        </div>
        {!showInput ? (
          <Element style={{ marginRight: 14.5 }}>
            <TextTwoLine text={item} />
          </Element>
        ) : (
          <div
            onClick={(e) => e.stopPropagation()}
            className="dFlex alignItemsCenter gap1 flex1"
          >
            <InputRename
              defaultValue={item}
              style={{ lineHeight: '17px' }}
              setShowInput={setShowInput}
              setIsShowRename={setIsShowRename}
              isShowRenameOnly={isShowRenameOnly}
              setIsShowRenameOnly={setIsShowRenameOnly}
              rowId={rowId}
              colId={colId}
            />
          </div>
        )}

        {!isShowRenameOnly && !showInput && !!isRename && (
          <div onClick={(e) => e.stopPropagation()}>
            <Button
              label={
                <Icon className="icon-edit-outline" style={{ fontSize: 15 }} />
              }
              action={() => {
                setShowInput(true)
              }}
              style={{
                color: '#D5D5D5',
                cursor: 'pointer',
                backgroundColor: 'transparent',
                border: 'none',
                opacity: showRename ? 1 : 0,
              }}
            />
          </div>
        )}
      </Element>
    </>
  )
}
